<template>
    <div style="background: #ff00ff;">
        <div style="width: 100%;height:50px;background: #ffffff;position: fixed;z-index:99;top: 0px">
            <div style="width: 50%;float: left;font-size: 15px;line-height: 50px;">全部分类</div>
            <div style="width: 50%;float: right;font-size: 15px;line-height: 50px">所有区域</div>
        </div>
        <ul style="width: 100%;margin-top: 60px;margin-bottom: 48px;z-index: 1;position: absolute">
            <li style="width: 100%; height: 130px" v-for="item in listArr" :key="item">
                <img style="width: 100px;height: 100px;display: block;float: left;margin: 15px;"
                     src=""/>
                <div style="float: left; height: 130px; position: relative;">
                    <div style="font-size: 15px;margin-top: 15px;">{{item['itemTitle']}}</div>
                    <div style="font-size: 12px;margin-top: 10px;width: 100px;">
                        (库存{{item['inventory']}}{{item['minUnitName']}})
                    </div>
                    <div style="font-size: 12px;position: absolute; bottom: 15px;width: 100px;">
                        {{item['storehouseName']}}
                    </div>
                </div>
            </li>
        </ul>
        <div style="position: fixed;z-index: 99">
            <van-tabbar v-model="active">
                <van-tabbar-item icon="home-o">库存</van-tabbar-item>
                <van-tabbar-item icon="search">调拨</van-tabbar-item>
                <van-tabbar-item icon="friends-o">待发货</van-tabbar-item>
                <van-tabbar-item icon="setting-o">出入库</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';

    export default {
        mixins: [head],
        data() {
            return {
                listArr: [],
                page: 1,
                pageSize: 10,
                loading: true,
                finished: false,
                indicatorType: 0,
                active: 0,
                indicatorMessage: ''
            };
        },
        created() {
            this.getData();
        },
        methods: {
            //获取列表数据
            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    page: this.page,
                    pagesize: this.pageSize
                };
                console.log('param', param);
                this.$http.post('item/companyStorehouseInout/listStorehouseItem.do', param, { toast: true })
                    .then((response) => {
                        this.$toast.clear();
                        this.data = response.data;
                        this.listArr = this.data['result'];
                    })
                    .catch((error) => {
                        console.log(error);
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                    });
            }
        }
    };
</script>

<style scoped>

</style>
